<style lang="scss" scoped>
.uploader {
	img {
		width: 65px;
		border: 3px solid transparent;
		&.\--chosen {
			border: 3px solid red;
			border-radius: 50%;
		}
	}
	&__file-upload {
		border: 1px dashed #dcdfe6;
		height: 100px;
		width: 100%;
		font-size: 20px;
		text-align: center;
		color: darken(#dcdfe6, 15);
		line-height: 100px;
		border-radius: 5px;
		&:hover {
			border-color: #c0c4cc;
		}
	}
	& /deep/ .croppie-container {
		.cr-boundary {
			margin: 0 auto;
			border-radius: 10px;
			height: 400px;
			width: 400px;
		}
		.cr-slider-wrap {
			margin-bottom: 0;
		}
	}
	.is-error {
		.file-upload {
			border: 1px solid #ff4949;
		}
	}
	&dom__image {
		margin-bottom: 50px;
	}
}
</style>


<template lang="pug">
    layout-modal.uploader
        .uploader__file-upload(@click="$refs.hiddenFile.click()", v-if="!file", style="cursor:pointer") Click to upload your own
            input(v-show="false", type="file", @change="processImage", ref="hiddenFile")
        .uploader__dom__image(v-show="file")
            vue-croppie(ref='croppieRef', :enableResize="false", :enableorientation='true', :viewport="{ width: 200, height: 200 }")
        template(slot="footer")
            el-row(:gutter="20")
                el-col(:span="12")
                    el-button(type="primary", @click="saveImage") Upload
                    //- el-button(@click="$vuedals.close()") Cancel
</template>

<script>
export default {
	props: {
		icon: {
			type: Object,
			default: () => ({
				type: null,
				value: null
			})
		}
	},
	data() {
		return {
			file: false,
			cropped: null
		};
	},

	mounted() {
		this.$refs.hiddenFile.click();
	},

	methods: {
		processImage(res, file) {
			var filesToUpload = this.$refs.hiddenFile.files;
			var file = filesToUpload[0];

			if (!["image/jpeg", "image/png"].includes(file.type)) {
				this.$refs.hiddenFile.value = "";
				this.$message.error("You can only upload png or jpg files");
				return;
			}

			var reader = new FileReader();

			reader.addEventListener(
				"load",
				() => {
					this.$refs.croppieRef.bind({
						url: reader.result
					});
					this.file = reader.result;
				},
				false
			);

			if (file) {
				reader.readAsDataURL(file);
			}
		},
		async saveImage() {
			this.$vuedals.close({
				type: "custom",
				value: await this.$refs.croppieRef.result({
					format: "jpeg",
					circle: false
				})
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/classroom/create/AvatarSelector/Upload.vue